import { api } from 'shared/api'

import { accountApplicationsSchemas } from './schemas'

export const AccountApplicationsApi = {
  getAppAction: api.account.createGet({
    url: '/accountApps/getAppAction',
    schemas: accountApplicationsSchemas.getAppAction,
  }),
  loadAppSource: api.account.createGet({
    url: '/accountApps/loadAppSource',
    schemas: accountApplicationsSchemas.loadAppSource,
  }),
  fetchApplicationsTriggers: api.account.createGet({
    url: '/accountApps/getTriggers',
    schemas: accountApplicationsSchemas.fetchApplicationsTriggers,
  }),
  getAppActions: api.account.createGet({
    url: '/accountApps/getAppActions',
    schemas: accountApplicationsSchemas.getAppActions,
  }),
}
